import {Component, OnInit, Inject, HostListener, ViewChild, ElementRef, Renderer2} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PanierService} from 'src/app/services/manage/panier/panier.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MediaObserver} from '@angular/flex-layout';
import {titleBannerAnim} from 'src/app/models/consts/anims';
import * as _ from 'lodash';
import {ProductService} from 'src/app/services/api/product/product.service';
import {FulleStockService} from 'src/app/services/api/fulle/fulle-stock/fulle-stock.service';
import {ProdcatService} from 'src/app/services/api/prodcat/prodcat.service';
import {MatSidenav} from '@angular/material/sidenav';
import {DialogsService} from "../../../services/manage/dialogs/dialogs.service";


@Component({
  selector: 'app-prod',
  templateUrl: './prod.component.html',
  styleUrls: ['./prod.component.css'],
  animations: [
    titleBannerAnim,
  ]
})
export class ProdComponent implements OnInit {
  loaderpop: boolean = false;
  loaderTransparent: boolean = false;
  @ViewChild('scrollHere') scrollHere: ElementRef | any;
  @ViewChild('fixedBar') fixedBar: ElementRef | any;
  @ViewChild('basketBtn') basketBtn: ElementRef | any;
  @ViewChild('titleBanner') titleBanner: ElementRef | any;
  @ViewChild('popupCont', {static: true}) popupCont: ElementRef | any;
  @ViewChild('sideNavCont') sideNavCont: ElementRef | any;
  @ViewChild('rightNav') rightNav: MatSidenav | any;
  @ViewChild('scrollFormuleSuggested') scrollFormuleSuggested: MatSidenav | any;

  /**
   * Image par default si aucune image
   */
  default_prod = 'https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png';

  /**
   * Dialog data
   */
  from: string;
  prodCopy: any;
  prod: any;
  index: number;
  products: any;

  /**
   * Galerie d'image du produit
   */
  prodGallery: any;


  /**
   * Dans le cas ou cest un produit de formule ou un produit avec du stock
   * Correspond à la quantité restante
   */
  maxQuantityRest: number | any;

  /**
   * Catégories du produit
   */
  categories: any;
  stockCats: any;

  /**
   * Tableau utilisé dans le side nav pour afficher les produits d'une formule
   */
  formuleDetails: any[] = [];

  /**
   * Side nav modes n co
   */
  opened: boolean | any;
  mode: string | any;

  /**
   * Handle scroll behaviors
   */
  titlePositionTop: number | any;
  titleBannerFlag = false;

  get getToggleTitle(): string {
    return this.titleBannerFlag ? 'show' : 'hide';
  }

  /**
   * Handle height && width
   */
  contHeight = '640px';
  contWidth: string | any;
  flagHeight = false;


  /**
   * stock
   */

  stockCopy: any;
  stock: any;

  unaivalable = false; // Flag permettant de rendre indisponible le produit de la popup indispo quand on le souhaite
  merchantClient: any;
  productSuggested: any;
  ObserLoaderformulesSuggestion: any;
  FormuleSuggested: any;
  catTogo: any = null;
  FormuleProdselected_id: any;
  ObserProductTypeformule: any;
  prod_type_formule: any;

  // Période de prix en cours
  idPricePeriod: any = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<ProdComponent>,
    private panierMan: PanierService,
    public dialogsService: DialogsService,
    private dialog: MatDialog,
    public media: MediaObserver,
    private renderer: Renderer2,
    public prodApi: ProductService,
    private stockApi: FulleStockService,
    private prodcatApi: ProdcatService
  ) {
    this.getObserLoaderFormulesSuggestion();
    // this.getObserProductTypeformule();
    this.from = data.from;
    this.index = data.index;
    this.merchantClient = data.merchantClient
    this.productSuggested = data.productSuggested ? data.productSuggested : false;
    this.FormuleSuggested = data.FormuleSuggested ? data.FormuleSuggested : false;
    this.FormuleProdselected_id = data.FormuleProdselected_id ? data.FormuleProdselected_id : false;


    // on fait une copy de stock  si existe
    this.stock = false;

    if (stockApi.stocks && !Array.isArray(stockApi.stocks && !this.stockCopy)) {
      this.stockCopy = _.cloneDeep(stockApi.stocks);

      if (data.prod.stock_prod_copy) {
        this.stockCopy[data.prod.id.toString()].count = data.prod.stock_prod_copy;
        data.prod.stock_prod_copy = null;
      }
      this.stock = true;

    }

    if (data.maxQuantityRest === 0 || data.maxQuantityRest) {
      this.maxQuantityRest = data.maxQuantityRest;
    } else {

      this.maxQuantityRest = data.prod.stock == null ? 99 : this.getprodStock(data.prod.id);


    }

    this.prod = data.prod;
    this.prodCopy = _.cloneDeep(data.prod);

    //categories   -> data categories est egale à prod.categories
    this.stockCats = _.cloneDeep(data.categories);


    if (data.prod.product_type > 0) {
      this.categories = this.initData(this.stockCats);


      //check le min et le max et set min et max en distinct_selection
      //  this.checkMaxMinQuantityWithDistinct_selection();


    }

    if (this.from === 'formule') {
      this.prodCopy.quantity = 1;
    }
  }

  checkMaxMinQuantityWithDistinct_selection() {
    if (this.categories && this.categories.length > 0) {
      this.categories.forEach((cat: any) => {
        //type 1 option
        if (cat.distinct_selection && cat.type == 1) {
          //cat_min ne peut etre superieur au nombre d'option
          cat.min_quantity = cat.min_quantity > cat.details.length ? cat.details.length : cat.min_quantity;
          //cat_max ne peut etre superieur au nombre d'option
          cat.max_quantity = cat.max_quantity > cat.details.length ? cat.details.length : cat.max_quantity;

        }
      });
    }
  }

  ngOnInit() {

    if(this.prodCopy.prices && this.prodCopy.prices.length > 0 && this.prodCopy.prices[0].id_price_period > 0){
      this.idPricePeriod = this.prodCopy.prices[0].id_price_period
    }

    /**
     * Récupère les noms des allergenes du produit
     */
    this.prodCopy.allergens = this.prodApi.parseAllergens(this.prodCopy.allergens);


    /**
     * Gere le responsive de la page
     */
    this.getRespSideNav();


    // verifie les stocks et le display

    if (this.prodCopy.product_type == 2 && this.prodCopy.categories.length > 0 && !this.prodCopy.details) {
      this.stockApi.ManStockFormuledisplay(this.prodCopy);
      this.maxQuantityRest = this.prodCopy.maxQuantityRest;
    }
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit() {


    /**
     * Gère la height et la width du component dynamiquement
     */
    setTimeout(() => {
      this.initHeightWidthAndPos();

    }, 200);

  }

  ngOnDestroy(): void {


    if (this.ObserLoaderformulesSuggestion) {
      this.ObserLoaderformulesSuggestion.unsubscribe();
    }
    if (this.ObserProductTypeformule) {
      this.ObserProductTypeformule.unsubscribe();
    }
  }

  /**
   * @description observable  getObserLoaderProductSuggestion
   */
  getObserLoaderFormulesSuggestion() {
    this.ObserLoaderformulesSuggestion == this.prodApi.getObserLoaderFormulesSuggested().subscribe((value: any) => {

      if (value) {

        this.loaderpop = value.value;
        this.loaderTransparent = value.value ? true : false;
        if (value.close) {
          this.prodApi.setObserLoaderFormulePSuggested(false);
          this.dialogRef.close();

        }
      }
    })
  }

  /**
   * @description observable  ObserProductTypeformule
   */
  getObserProductTypeformule() {
    this.ObserProductTypeformule == this.prodApi.getObserProductTypeformule().subscribe((value: any) => {


      this.prod_type_formule = value;


    })
  }

  /**
   * @description Initialise les catégories du produit et les détails
   * @param {any[]} cats
   * @returns {any[]}
   */
  initData(cats: any): any[] {


    let prodCats: any = [];

    /**
     * Récupère les catégories du produit
     */


    prodCats = cats;


    /**
     * Parse details of current categories
     */
    prodCats.map((prodCat: any) => {

      /**
       * Set l'id de la catégorie et la quantité à 0 sur le détail (Utile pour la suite)
       */


      prodCat.details.map((catDetail: any) => {


        catDetail.product.cat = parseInt(prodCat.id);

        catDetail.product.quantity = 0;

        // if stock
        if (this.stock) {

          // on recupere les stocks
          catDetail.product.stock = this.stockApi.stocks[catDetail.product.id.toString()];

          if (catDetail.product.stock) {

            // on cache le toogle si stock et formule
            catDetail.product.has_stock = true;


            // on modifie le maxQuantity
            this.maxQuantityRest = null;

          }
        }
      });

      /**
       * Trie les détails par nom
       */
      if (this.prodCopy.product_type === 2) {

        prodCat.details = prodCat.details.sort((a: any, b: any) => a.product['order_name'].localeCompare(b.product['order_name']));
      }

    });

    /**
     * Si la popup a été ouverte pour modification de produit alors on set toutes les valeurs en fonction de celles du produit
     */
    if (this.from === 'update' || this.from === 'updatedetail') {

      /**
       * On remplace toutes les valeurs par celles qu'on connait du produit
       */

      if (this.prodCopy.stock && this.prodCopy.product_type == 1) {

        this.prodCopy.update = true;
      }


      prodCats.map((prodCat: any) => {


        prodCat.details.map((catDetail: any) => {

          this.prodCopy.details.map((prodDet: any) => {

            if (parseInt(catDetail.product.id) === prodDet.id) {


              //  if (catDetail.product.quantity > 0 ) {
              //   prodDet.cat = prodCat.id;

              // }


              if (prodDet.cat == catDetail.product.cat) {
                prodDet.cat = prodCat.id;
              }


              if (this.prodCopy.product_type === 2) {

                if (prodDet.cat == catDetail.product.cat) {
                  catDetail.product.quantity += prodDet.quantity;
                }


                // stock in update
                if (catDetail.product.stock && catDetail.product.quantity > 0) {
                  catDetail.product.update = true;
                }

              } else {
                catDetail.product.quantity = prodDet.quantity;

              }

            }
          });


        });
      });


    }


    /**
     * Si c'est un produit de type formule alors on initialise le tableau des détails de la formule
     */
    if (this.prodCopy.product_type === 2) {

      this.initFormuleDetails(prodCats);


      /**
       * Si cest une popup de type ajout alors on gère les rubriques automatiques
       */
      if (this.from === 'add') {

        this.handleAutomaticFormule(cats);
      }

    }

    /**
     * Si cest un produit avec option autre qu'une formule alors on trie par ordre alphabetique
     */
    if (this.prodCopy.product_type < 2) {

      /**
       * On trie les catégories par id
       */
      prodCats = prodCats.sort(function (a: any, b: any) {
        return a.name - b.name;
      });

    }


    return prodCats;


  }

  /**
   * @description Gère la quantité du produit
   * @param {string} what
   * @return {void}
   */
  toggleProdQuant(what: string): void {


    if (what === '+') {

      if (
        !this.maxQuantityRest
        || this.maxQuantityRest && this.prodCopy.quantity < this.maxQuantityRest
      ) {
        this.prodCopy.quantity++;
      }

    } else if (what === '-') {

      if (this.prodCopy.quantity > 1) {
        this.prodCopy.quantity--;

      }

    }

  }


  toggleProdQuantDet(what: string, cat: any, myDet: any): void {


    let count = 0;


    cat.details.map((det: any) => {
      count += det.product.quantity;
    });

    if (what === '+') {

      if (!cat.distinct_selection) {
        if (count < cat.max_quantity) {
          myDet.quantity++;
        }
      } else {
        // distinct_selection un seul choix max par option et le tout inferieur a maxquantity

        if (myDet.quantity < 1 && count < cat.max_quantity) {
          myDet.quantity++;
        }
      }

    } else if (what === '-') {
      if (myDet.quantity > 0) {
        myDet.quantity--;
      }

    }

  }

  /**
   * @description Remet la quantité à 0 de tous les produits d'une categorie
   * @param {any} cat
   * @return {void}
   */
  removeProdCat(cat: any, reset?: any): void {


    cat.details.map((det: any) => {

      det.product.quantity = 0;

      if (det.product.stock) {

        if (reset && det.product.update) {

          // on changer tous les produits avec stock
          this.formuleDetails.map(formCat => {

            if (formCat.id === cat.id) {

              formCat.details.map((detCat: any) => {

                if (detCat.id === det.product.id) {

                  if (det.product.stock.newcount && det.product.stock.newcount < 0) {
                    det.product.stock.newcount += detCat.quantity;


                    if (det.product.stock.newcount >= 0) {

                      // det.product.stock.count += detCat.quantity;
                      this.stockCopy[det.product.id.toString()].count += detCat.quantity;
                    }
                  } else {
                    // det.product.stock.count += detCat.quantity;
                    this.stockCopy[det.product.id.toString()].count += detCat.quantity;


                  }

                }
              });
            }
          });

        }


      }

    });

    // on efface
    this.formuleDetails.map(formCat => {
      if (formCat.id === cat.id) {
        formCat.details = [];
      }
    });


  }


  /**
   * @description Compte la quantité par catégorie restante
   * @param {any} cat
   * @return {number}
   */
  getMaxQuantity(cat: any, prod: any): number {


    let quantityCount = 0;

    cat.details.map((det: any) => {

      const detQuant = det.product && det.product.quantity ? det.product.quantity : det.quantity;

      if (detQuant > 0) {
        quantityCount += detQuant;
      }
    });


    /**
     * Si le produit a un stock et que le stock est superieur à 0
     * et que le stock et plus petit ou égal à la quantité max de la categorie alors on se base sur le stock
     * sinon sur la quantité maximum de la categorie
     */

    const cal = cat.max_quantity - quantityCount;

    let maxQuant = cal;

    if (prod.stock && this.getprodStock(prod.id) > 0) {
      maxQuant = this.getprodStock(prod.id) <= cal ? this.getprodStock(prod.id) : cal;


    }

    return maxQuant;


  }

  /**
   * @description Gère les bouttons radio
   * @param {any} catDet
   * @param {any} myDet
   * @return {void}
   */
  manageRadio(catDet: any, myDet: any): void {
    catDet.map((det: any) => {
      if (det.product.id !== myDet.id) {
        det.product.quantity = 0;
      }
    });
    myDet.quantity = 1;
  }

  /**
   * @description Gère les checkbox
   * @param {any} cat
   * @param {any} myDet
   * @return {void}
   */
  manageCheckBox(cat: any, myDet: any): void {

    myDet.quantity === 0 ? myDet.quantity = 1 : myDet.quantity = 0;
    let count = 0;

    cat.details.map((det: any) => {
      count += det.product.quantity;
    });


    if (count > cat.max_quantity) {
      cat.details.map((det: any) => {

        if (parseInt(det.product.id) !== parseInt(myDet.id)) {
          det.product.quantity = 0;

        }
      });
    }
  }

  /**
   * @description Manage la quantité des produits de formule
   * @param {any} cat
   * @param {string} from
   * @return {boolean}
   */
  manageProdFormule(cat: any, from?: string): boolean {

    const maxQuant = cat.max_quantity;

    let count = 0;


    _.map(cat.details, det => {
      count += (det.product) ? det.product.quantity : det.quantity;
    });

    if (from === 'dialog') {

      if (maxQuant === 1 && count === 1) {

        return true;

      } else {

        return count === maxQuant ? false : true;

      }

    } else {

      return count > 0 ? false : true;

    }

  }


  checkErrorProdSugested() {
    if (this.checkError()) {
      /**
       * Si le produit est de type produit avec option ou de type formule
       * alors on implémente les détails et les catégories
       */
      const details: any = []; // Les détails du produit
      if (this.prodCopy.product_type > 0) {

        this.categories.map((cat: any) => {


          cat.details.map((det: any) => {
            if (det.product.quantity > 0) {
              details.push(det.product);
            }
          });

        });

      }

      this.prodCopy.categories = this.categories;
      this.prodCopy.details = details;

      this.dialogRef.close(this.prodCopy);
    }
  }

  /**
   * @description  verifie si formule suggestions
   * @return {void}
   */
  pushProd(): void {
    //formule suggestions


    if (this.prodCopy.rubric && this.prodCopy.rubric.enable_menu_suggestion && !this.productSuggested && !this.FormuleSuggested && this.prodCopy.quantity == 1 && this.prodCopy.product_type < 2 && this.from == 'add'
    ) {

      if (this.checkError()) {
        this.prodApi.getFormulesAuto(this.prodCopy, this.merchantClient, this.categories).then((parsedProds: any) => {
          if (!parsedProds || (parsedProds && parsedProds.products && parsedProds.products.length == 0)) {
            this.pushProdBasket();
          }
        });
      }
    } else {

      // Ajoute le produit au panier
      this.pushProdBasket();
    }


  }

  /**
   * @description Ajoute le produit au panier (panier formule ou panier commande)
   * @return {void}
   */
  pushProdBasket(): void {

    if (this.FormuleSuggested) {
      this.prod = this.prodCopy;
    }

    //product suggested
    if (this.productSuggested) {
      this.prodCopy.product_type > 0 ? this.checkErrorProdSugested() : this.dialogRef.close(this.prodCopy);
      return;
    }

    /**
     * On check toutes les catégories obligatoires sont renseignées
     */
    if (this.checkError()) {

      this.parseProd();


      if (this.from === 'updatedetail') {


        // Nothing yet

        /**
         * Si cest un produit qui ne vient pas d'une formule et qu'il n'est pas de type formule
         */
      } else if (this.prodCopy.product_type < 2 && this.from !== 'formule') {

        this.from === 'add'
          ? this.panierMan.manageProduct(this.prodCopy, this.stockApi.stocks)
          : this.panierMan.manageProduct(this.prodCopy, this.stockApi.stocks, this.index);

        //affichage
        if (this.prodCopy.stock) {
          this.stockApi.setCurrStock(this.prodCopy.id, this.prodCopy.stock.count);
        }


        /**
         * Si cest un produit de type formule
         */
      } else if (this.prodCopy.product_type === 2) {

        if (this.stock) {


          //on delete   +les stocks (incremente)

          if (!this.FormuleSuggested) {
            if (this.prod.details) {
              this.prod.details.forEach((element: any) => {

                this.delete_stock(element);
              });
            }
          }


          //on add    -les stocks

          this.prodCopy.categories.forEach((element: any) => {
            if (element.details) {
              element.details.forEach((val: any) => {

                this.update_stock(val.product);
              });
            }
          });


        }


        if (this.FormuleSuggested && this.prodCopy.stock) {
          //affichage des stock produit rubric soit actualisé
          this.stockApi.setCurrStock(this.prodCopy.id, this.prodCopy.stock.count);
        }

        this.from === 'add'
          ? this.panierMan.manageProductFormule(this.prodCopy, this.parseFormuleDetails(), this.stockApi.stocks)
          : this.panierMan.manageProductFormule(this.prodCopy, this.parseFormuleDetails(), this.stockApi.stocks, this.index);

      }

      /**
       * Close le dialog
       */


      this.dialogRef.close(this.prodCopy);


    }

  }

  manageStockProd() {
    for (const key in this.stockCopy) {

      this.stockApi.stocks[key.toString()].count = this.stockCopy[key.toString()].count;
    }
  }

  /**
   * @description Change la quantité d'un produit et dans le stock
   * @param {any} prod
   */
  update_stock(prod: any) {


    // prod et prod copy

    if (prod.stock) {
      prod.stock.count = this.stockApi.handleProdStock(prod.id, prod.quantity, "remove", prod.stock.newcount);

    }

    if (prod.details) {

      prod.details.map((det: any) => {

        if (det.stock) {
          det.stock.count = this.stockApi.handleProdStock(det.id, prod.quantity, "remove", det.stock.newcount);

        }
      })
    }


    return prod;

  }


  delete_stock(prod: any) {


    // prod et prod copy

    if (prod.stock) {
      prod.stock.count = this.stockApi.handleProdStock(prod.id, prod.quantity, "add", prod.stock.newcount);
    }

    if (prod.details) {

      prod.details.map((det: any) => {

        if (det.stock) {
          det.stock.count = this.stockApi.handleProdStock(det.id, prod.quantity, "add", det.stock.newcount);

        }
      })
    }

    return prod;
  }


  /**
   * @description Check si il y a des erreurs (Catégorie obligatoire)
   * @return {boolean}
   */
  checkError(): boolean {


    const errors: string[] = [];

    if (this.prodCopy.product_type === 0) {
      return true;
    }


    this.categories.map((cat: any) => {


      let count = 0;


      cat.asError = false;

      // if (cat.compulsory === 1 ) {
      if (cat.min_quantity > 0) {

        cat.details.map((det: any) => {
          count += det.product.quantity;
        });


      } else {
        count = 1;
      }


      if (count === 0 || (cat.min_quantity > 0 && count < cat.min_quantity)) {

        cat.asError = true;
        errors.push(cat.id);
      }

    });


    if (errors.length > 0) {
      setTimeout(() => {
        const objDiv: any = document.getElementById(errors[0]);
        objDiv.scrollIntoView({behavior: 'smooth'});
      });
      return false;
    } else {
      return true;
    }
  }

  /**
   * @description Parse le produit avant de fermer la popup
   * @return {void}
   */
  parseProd(): void {


    const details: any = []; // Les détails du produit
    const currCats: any = []; // Les catégories du produit

    /**
     * On retire les produit du stock sur la copy et le vrai produit
     */

    if (this.prod.stock && this.prod.stock.count) {

      this.initStock();

    }


    /**
     * Si le produit est de type produit avec option ou de type formule
     * alors on implémente les détails et les catégories
     */

    if (this.prodCopy.product_type > 0) {

      this.categories.map((cat: any) => {

        //avant
        // const newObjId = { id: cat.id };
        // currCats.push(newObjId);

        cat.details.map((det: any) => {
          if (det.product.quantity > 0) {
            details.push(det.product);
          }
        });

      });

    }

    this.prodCopy.categories = this.categories;
    this.prodCopy.details = details;


  }


  initStock() {


    if (this.prod.stock.count > 0 && !this.prod.has_stock && !this.prodCopy.update) {
      this.prod.stock.count -= this.prodCopy.quantity;

    } else if (this.prodCopy.update && this.prodCopy.product_type == 1 && this.from != 'formule') {


      const ecart = this.prod.quantity - this.prodCopy.quantity;
      this.prod.stock.count += ecart;

    }
    this.prodCopy.stock = this.prod.stock;

    this.stockApi.stocks[this.prodCopy.id.toString()].count = this.prodCopy.stock.count;

    if (this.prodCopy.update && this.prodCopy.product_type == 1) {

      //affichage
      this.stockApi.setCurrStock(this.prodCopy.id, this.prodCopy.stock.count);
    }

  }


  /**
   * Formule details
   */

  // Init the formule details
  initFormuleDetails(cats: any): void {

    const cloneCats = _.cloneDeep(cats);


    // Remove details
    cloneCats.map((cat: any) => {
      cat.details = [];
    });


    if (this.from === 'update') {
      // Increment details by categorie
      cloneCats.map((cat: any) => {

        this.prodCopy.details.map((prodDet: any) => {
          if (prodDet.cat === cat.id) {
            cat.details.push(prodDet);
          }
        });
      });
    }

    this.formuleDetails = cloneCats;


  }

  // Add a detail to the formule
  incrementFormuleDetails(prod: any): void {

    this.formuleDetails.map(cat => {

      if (cat.id === prod.cat) {
        cat.details.push(prod);
      }
    });

  }

  /**
   * @description Gère les formules automatiques
   */
  handleAutomaticFormule(cats: any): void {


    /**
     * On boucle sur les catégories
     */
    cats.map((cat: any) => {

      /**
       * Si la catégorie gère les formule auto
       */
      if (cat.automatic === 1) {

        /**
         * Si la catégorie n'a qu'un détail alors on le selectionne x la max quantity
         */
        if (cat.details.length === 1) {

          /**
           * Si le produit a du stock et que la max quantité est >= au stock alors on peut push les produits
           */
          if (cat.details[0].product.stock) {

            this.unaivalable = (cat.max_quantity >= cat.details[0].product.stock.count) ? true : false;

          }

          /**
           * On ajoute le produit si il n'a pas d'option
           */
          if (!this.unaivalable && cat.details[0].product.product_type < 1) {

            cat.details[0].product.quantity = cat.max_quantity;

            if (cat.details[0].product.stock) {
              this.stockCopy[cat.details[0].product.id.toString()].count -= cat.max_quantity;

            }

            let i = 0;
            do {
              i += 1;
              this.incrementFormuleDetails(cat.details[0].product);
            } while (i < cat.max_quantity);

          }

        } else {

          /**
           * Si le nombre de détail dans la catégorie correspond exactement à la max quantity alors on en selectionne un de chaque
           */
          if (cat.details.length === cat.max_quantity) {

            let resetCat = false;

            for (let index = 0; index < cat.details.length; index++) {

              const detail = cat.details[index];

              /**
               * Si le produit gère les stock et n'a plus de stock ou si le produit a des options
               * alors on break et on efface reset la catégorie
               */
              if (detail.product.stock && detail.product.stock.count === 0 || detail.product.product_type === 1) {
                resetCat = true;
                break;
              }

              /**
               * On ajoute le produit
               */
              detail.product.quantity = 1;

              if (detail.product.stock) {
                this.stockCopy[detail.product.id.toString()].count -= 1;

              }

              this.incrementFormuleDetails(detail.product);

            }

            /**
             * Si le flag resetCat est à true alors on reset la catégorie
             */
            if (resetCat) {
              this.removeProdCat(cat);
            }

          }

        }

      }

    });


  }

  // Parse the formule details
  parseFormuleDetails(): any[] {


    const parsedArray: any = [];
    this.formuleDetails.map((cat: any) => {
      cat.details.map((det: any) => {
        det.quantity = 1;
        parsedArray.push(det);
      });
    });

    return parsedArray;

  }

  // Delete a formule detail
  deleteFormuleDetail(catId: number, detId: number, index: number): void {


    this.formuleDetails.map(cat => {
      if (cat.id === catId) {
        cat.details.splice(index, 1);
      }
    });


    this.categories.map((cat: any) => {
      if (cat.id === catId) {
        cat.details.map((det: any) => {
          if (det.product.id === detId) {
            det.product.quantity -= 1;

            // on modifie le stock
            if (det.product.stock) {
              //permet d'enlever au stock
              //  det.product.stock.count += 1
              this.stockCopy[det.product.id.toString()].count += 1;

            }
          }
        });
      }
    });


  }

  // Update a formule detail
  updateFormuleDetail(catId: number, index?: number | any, prod?: any, opt?: any): void {


    if (opt) {
      let checkdetail = this.getOptionFormule(prod);
      checkdetail.comment = prod.comment;
      checkdetail.details = prod.details;

    } else {


      this.formuleDetails.map(cat => {

        if (cat.id === catId) {
          cat.details[index].comment = prod.comment;
          cat.details[index].details = prod.details;
        }
      });
    }
  }

  /**
   * @description Return the total price of the formule
   * @return {number}
   */
  getTotalPriceFormule(): number {


    let total = 0;


    const prodPrice =
      this.from === 'add' ? this.prodCopy.prices[0].price :
        this.from === 'update' ? this.prodCopy.price :
          this.from === 'formule' || this.from === 'updatedetail' ? this.prodCopy.price : '';

    let prodPriceParsed = this.chechDiscount(prodPrice, this.prodCopy);


    total += prodPriceParsed;


    if (this.prodCopy.product_type === 1) {


      this.categories.map((cat: any) => {

        cat.details.map((detCat: any) => {
          if (detCat.product.quantity > 0) {


            // total += (detCat.product.quantity * parseFloat(detCat.product.price));

            total += (detCat.product.quantity * this.chechDiscount(detCat.product.price, detCat.product));

          }
        });
      });

    } else if (this.prodCopy.product_type === 2) {


      // on recalcul

      this.formuleDetails.map(cat => {


        if (cat.details.length > 0) {

          cat.details.map((det: any) => {


            const detPrice = (det.price >= 0) ? det.price : det.price;

            if (det.details && det.details.length > 0) {

              det.details.map((sdet: any) => {

                total += (this.chechDiscount(sdet.price, sdet) * sdet.quantity);

              });
            }
            total += (this.chechDiscount(detPrice, det) * det.quantity);


          });
        }
      });

    }


    let result: any = this.from === 'formule' ? total : Math.round((total * this.prodCopy.quantity) * 100) / 100;


    return result;
  }


  getNewPricewithDiscountProdPrice(prodCopy: any, price: any) {


    price = (this.prodCopy.quantity * this.chechDiscount(price, this.prodCopy));


    return price

  }


  /**
   * @description Return the total amount of prod in formule basket
   * @return {number}
   */
  getTotalQuantFormule(): number {
    let prodQuant = 0;
    this.categories.map((cat: any) => {
      if (cat.details.length > 0) {
        cat.details.map((det: any) => {
          prodQuant += det.product.quantity;
        });
      }
    });
    return prodQuant;
  }

  /**
   * @description Return the total price of prod line
   * @return {number}
   */
  getTotalProdPrice(det: any): number {


    let totalPriceDet = det.price;

    if (det.details && det.details.length > 0) {
      det.details.map((det: any) => {
        totalPriceDet += (this.chechDiscount(det.price, det) * det.quantity);
      });
    }
    return (Math.round((totalPriceDet * det.quantity) * 100) / 100);
  }


  getOptionFormule(prod: any) {

    let check = this.formuleDetails.find((value: any) => value.id == prod.cat);
    let checkdetail = check ? check.details.find((value: any) => value.id == prod.id) : null;
    return checkdetail;
  }


  /**
   *
   * @description recupere les categories du produit api  avant d'ouvrir la pop
   * @param {any} prod
   * @param {string} from
   * @param {any} cat
   * @param {number} index
   * @param {boolean} info
   * @return {void}
   */

  openProdDial(prod: any, from: string, cat: any, index?: number, info?: boolean) {


    //recupere les categories du produit api
    this.prodcatApi.getApiProdCatsByIdProd(prod).subscribe((cats) => {


      prod.categories = cats;

      // prod.details = [];
      this.openPreProdDial(prod, from, cat, index, info);
    });

  }


  /**
   *
   * @description Ouvre la popup produit pour les produit de formule
   * @param {any} prod
   * @param {string} from
   * @param {any} cat
   * @param {number} index
   * @param {boolean} info
   * @return {void}
   */
  openPreProdDial(prod: any, from: string, cat: any, index?: number, info?: boolean): void {


    //on recupere les infos options en cas de modification de formule  et  prod.product_type > 0
    let opt = false;

    // pour avoir les categories
    if (this.from == "update" && from == "formule" && prod.product_type > 0) {

      this.prodCopy.details = [];
      let checkCat = cat.details.find((value: any) => (value.product.id == prod.id) && value.product.quantity > 0);

      if (checkCat) {

        let checkdetail = this.getOptionFormule(prod);
        //pour parser
        from = checkdetail ? "updatedetail" : from;

        if (checkdetail) {
          //set le details des produits option
          prod.details = checkdetail.details;
          this.prodCopy.details = this.prod.details;
          //permet de actualiser les formulesdetails
          opt = true;
        }
      }

    }


    // On ouvre la popup si...

    if (cat.max_quantity > 1 || info === true || from === 'updatedetail' || prod.product_type > 0) {

      // si  stock et  superieur à 0

      if (!prod.stock || (prod.stock && this.getprodStock(prod.id)) > 0) {


        const checkCount = (from !== 'updatedetail') ? this.manageProdFormule(cat, 'dialog') : true;


        if (checkCount) {

          const myConf = new MatDialogConfig();

          if (this.media.isActive('xs')) {
            myConf.panelClass = 'full-screen';
          } else {
            myConf.width = prod.product_type === 2 ? "780px" : "450px";
            myConf.maxHeight = '700px';
          }

          myConf.autoFocus = false;

          myConf.data = {


            index: index,
            from: from,
            prod: prod,
            maxQuantityRest: this.getMaxQuantity(cat, prod),
            // categories: this.stockCats,
            categories: prod.categories,
          };

          if (prod.stock) {
            myConf.data.prod.stock_prod_copy = this.getprodStock(prod.id);

          }


          myConf.data.merchantClient = this.merchantClient ? this.merchantClient : null;

          const myDial = this.dialog.open(ProdComponent, myConf);

          myDial.afterClosed().subscribe(result => {

            if (result) {


              if (from === 'updatedetail') {

                this.updateFormuleDetail(cat.id, index, result, opt);

              } else {


                if (cat.max_quantity === 1) {
                  this.removeProdCat(cat);
                }


                // si formule avec stock et cat max > 1

                if (prod.has_stock && cat.max_quantity > 1) {

                  prod.quantity += result.quantity;
                  this.updateFormulestockDetailCatmax(cat, prod, result);

                } else {

                  prod.quantity += result.quantity;


                  let i = 0;
                  do {
                    i += 1;
                    this.incrementFormuleDetails(result);
                  } while (i < result.quantity);

                }
              }

            }

            //scroll other categorie
            this.scrollToCatAuto();

            this.basketAlertAnim();

          });
        }

      }

    } else {


      if (prod.has_stock) {

        let flag = false;

        if (prod.stock) {
          flag = this.getprodStock(prod.id) > 0 ? flag : true;
        }

        if (!flag) {
          this.removeProdCat(cat);
          this.updateFormulestockDetail(cat, prod);
          this.increment(prod);
        }
      } else {
        this.removeProdCat(cat);
        this.increment(prod);
      }


      this.scrollToCatAuto();


    }


  }

  /**
   * @description dirige vers incrementFormuleDetails
   * @param {any} prod
   */
  increment(prod: any) {
    prod.quantity += 1;
    prod.details = [];
    this.incrementFormuleDetails(prod);
  }

  /**
   * @description  Update le stock d'un produit (detail d'une formule avec stock)
   * @param {any} prod
   */
  updateFormulestockDetail(cat: any, prod: any) {


    cat.details.map((det: any) => {

      if ((prod.id === det.product.id)) {
        if (det.product.stock && !det.product.update) {
          // on  modifie le stock produit
          this.stockCopy[det.product.id.toString()].count -= 1;
        }

      } else if (det.product.stock && det.product.update) {
        this.stockCopy[det.product.id.toString()].count += 1;

      }


    });


  }


  /**
   * @description  retourne le stock
   * @param {any} id
   */
  //

  getprodStock(id: any) {

    return this.stockCopy[id.toString()].count;
  }


  /**
   * @description modifie le stock formule avec cat max >1 et incremente le prod
   * @param {any} cat
   * @param {any} prod
   * @param {any} result
   *
   */
  //
  updateFormulestockDetailCatmax(cat: any, prod: any, result: any) {


    let count = 0;
    let flag = true;

    cat.details.map((det: any) => {
      count += det.product.quantity;
    });


    if ((count <= cat.max_quantity)) {

      if (prod.stock && this.stockCopy[prod.id.toString()].count > 0) {

        if (prod.stock && (this.stockCopy[prod.id.toString()].count - result.quantity) >= 0) {
          this.stockCopy[prod.id.toString()].count -= result.quantity;
          flag = false;
        }

      } else if (!prod.stock) {
        flag = false;
      }


      if (!flag) {

        const toincrementqte = _.cloneDeep(result.quantity);

        for (let i = 0; i < toincrementqte; i++) {
          result.quantity = 1;
          this.incrementFormuleDetails(result);
        }
      }


    }

  }

  /**
   * @description Check si le produit gere le stock et si il lui en reste
   * @return {boolean}
   */
  conditionStock(): boolean {

    const conditionStock = !this.prodCopy.stock ? true : this.getprodStock(this.prodCopy.id) > 0 ? true : false;
    return conditionStock;

  }

  getUpdateFrom() {
    return this.from == 'update' || this.from == "updatedetail" ? false : true;
  }


  /**
   * @description Gère le comportement en responsive
   * @return {void}
   */
  getRespSideNav(): void {

    if (this.prodCopy.product_type === 2) {

      if (this.media.isActive('lt-md')) {

        this.opened = (this.from === 'update') ? true : false;
        this.mode = 'over';

      } else {

        this.opened = true;
        this.mode = 'side';

      }

    } else {

      this.opened = false;

    }
  }

  /**
   * @description Gère le comportement de la hauteur et de la longueur du composant
   * @return {void}
   */
  initHeightWidthAndPos(): void {


    // Set title scroll position
    this.titlePositionTop = this.scrollHere.nativeElement.getBoundingClientRect().top;

    // Get sideNavCont width to make a square with img.
    this.contWidth = this.sideNavCont.nativeElement.offsetWidth.toString() + 'px';


    // If cont height is bigger than window height do some things...

    if (this.popupCont && this.popupCont.nativeElement.offsetHeight >= window.innerHeight) {
      setTimeout(() => {
        this.flagHeight = true;
        this.contHeight = ((window.innerHeight - (this.media.isActive('xs') ? 50 : 60)).toString()) + 'px';
      }, 300);
    }

    /**
     * Scroll vers le titre
     */
    setTimeout(() => {

      this.scrollHere.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'});

    }, 200);


    if (this.FormuleSuggested) {


      setTimeout(() => {
        if (this.media.isActive('xs')) {
          this.rightNav.close();

        }
      }, 200);


    }

    this.scrollToCatAuto("start");


  }


  /**
   * get categories product selected formule suggestions
   */
  scrollToCatAuto(start?: any) {


    let categories = _.cloneDeep(this.categories);

    // && this.prod_type_formule
    if (categories && categories.length > 0 && this.prodCopy.product_type == 2) {


      let cats: any = []
      categories.forEach((el: any) => {
        let flag = false;
        if (el.details && el.details.length > 0) {
          el.details.forEach((elDetails: any) => {

            if (elDetails.product && elDetails.product.id) {
              flag = true;
            }
          })
        }
        if (flag) {
          cats.push(el);
        }
      });


      if (cats && cats.length > 0) {

        cats.forEach((el: any) => {

          let quantity = 0;

          if (el.details && el.details.length > 0) {
            el.details.forEach((elDetails: any) => {

              if (elDetails.product && elDetails.product.id && elDetails.product.quantity) {
                quantity += elDetails.product.quantity;
              }
            })
          }


          el.full = (start && el.min_quantity && (el.min_quantity < el.max_quantity && quantity >= el.min_quantity)) || el.max_quantity && (quantity == el.max_quantity) ? true : false;
        });


        let qte = 0;

        for (let index = 0; index < cats.length; index++) {
          const element = cats[index];

          if (element.full) {
            qte++;
          }
        }

        if (qte != cats.length) {


          for (let index = 0; index < cats.length; index++) {
            const element = cats[index];

            if (index == 0 && !element.full) {

              this.catTogo = 0;
              break;
            } else if (this.categories[index + 1] && !cats[index + 1].full) {

              this.catTogo = index + 1;
              break;
            } else if (this.categories[index - 1] && !cats[index + 1].full) {

              this.catTogo = index - 1;
              break;
            }
          }


          //scroll
          if (this.catTogo !== null) {
            setTimeout(() => {


              if (this.catTogo == 0) {
                this.scrollHere.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'});
              } else {
                if (this.FormuleSuggested && this.scrollFormuleSuggested) {
                  this.scrollFormuleSuggested.nativeElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'start'
                  });
                } else {


                  let index = 'catScroll_' + this.catTogo;
                  let objDiv: any = document.getElementById(index);
                  if (objDiv) {
                    objDiv.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
                  }
                }
              }

            }, 200);
          }
        }
      }
    }


  }

  /**
   * @description Listener de scroll
   * @param {any} event
   */
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    this.animBottomFixedBar(event);
  }

  /**
   * @description Gère le comportement de la barre de titre
   * @param {any} event
   * @return {void}
   */
  animTitle(event: any): void {
    if (event.target.scrollTop >= this.titlePositionTop) {
      this.titleBannerFlag = true;
      this.renderer.addClass(this.titleBanner.nativeElement, 'dark');
    } else {
      this.titleBannerFlag = false;
      this.renderer.removeClass(this.titleBanner.nativeElement, 'dark');
    }
  }

  /**
   * @description Gère le comportement de la barre fixe du bas
   * @param {any} event
   * @return {void}
   */
  animBottomFixedBar(event: any): void {
    (event.target.scrollTop > 1) ? this.renderer.addClass(this.fixedBar.nativeElement, 'shadowed-footer-prod') : this.renderer.removeClass(this.fixedBar.nativeElement, 'shadowed-footer-prod');
  }

  /**
   * @description Gère le comportement de l'icon panier
   * @return {void}
   */
  basketAlertAnim(): void {
    this.renderer.removeClass(this.basketBtn.nativeElement, 'animAlert');
    setTimeout(() => {
      this.renderer.addClass(this.basketBtn.nativeElement, 'animAlert');
    });
  }


  /**
   * @description chech Discount
   * @params price
   * @params prod
   */
  chechDiscount(price: any, prod: any) {


    let newVal: any = parseFloat(price);

    if (this.merchantClient && this.merchantClient.id_group) {

      if (this.merchantClient.discount) {
        newVal = price * ((100 - this.merchantClient.discount) / 100)
      }

      if (this.merchantClient.groups_discount && this.merchantClient.groups_discount.length > 0 && prod && prod.rubric) {


        let discount_prod_rubric = this.merchantClient.groups_discount.find((value: any) => value.id_rubric == prod.rubric.id);


        if (discount_prod_rubric) {
          newVal = price * ((100 - discount_prod_rubric.discount) / 100);
        }

      }

    }
    return (Math.round(newVal * 100) / 100);
  }
}


